export default __webpack_public_path__ + "static/media/googlemapsicon.a2d8910f.png";